import { createSlice } from '@reduxjs/toolkit';

// Define the reducer logic for 'twoSlice'
const customUserSlice = createSlice({
  name: 'userState',
  initialState: {
    userData: [],
    userLogData: {},
    loading: false
  },
  reducers: {
    setUserData(state, action) {
      state.userData = action.payload;
    },
    setUserLogData(state, action) {
      state.userLogData = action.payload;
    },
    setUserLogDataLoading(state, action) {
      state.loading = action.payload;
    },
  },
});

export const { setUserData, setUserLogData, setUserLogDataLoading } = customUserSlice.actions;

export default customUserSlice;
